import cn from "classnames";
import { CloseIcon, ReplyIcon } from "../../../../../../packages/icons";
import styles from "./reply.module.scss";

type Props = {
  showIcon?: boolean;
  onClick?: () => void;
  onClear?: () => void;
  name: string;
  text: string;
  height: number;
  dataTestId: string;
};

const Reply = ({
  showIcon = true,
  onClick,
  onClear,
  name,
  text,
  height,
  dataTestId,
}: Props) => {
  const replyIcon = (
    <div className={styles["reply-icon"]}>
      {showIcon && <ReplyIcon color="#5ABF5C" size={24} />}
    </div>
  );

  const clearIcon = (
    <div onClick={onClear} className={styles["reply-close-icon"]}>
      <CloseIcon size="medium" />
    </div>
  );

  const messageContent = (
    <div className={styles["reply-message"]}>
      <div
        data-test-id="reply-author-name"
        className={cn(styles["reply-text"], styles["reply-author"])}
      >
        {name}
      </div>
      <div
        data-test-id="reply-message-text"
        className={cn(styles["reply-text"], styles["reply-content"])}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );

  const className = cn(styles["reply-container"], {
    [styles.clickable]: onClick,
    [styles["reply-container-without-icon"]]: !showIcon,
  });

  return (
    <div
      className={className}
      style={{ height: `${height}px` }}
      data-test-id={dataTestId}
      onClick={onClick}
    >
      {replyIcon}
      {messageContent}
      {showIcon && clearIcon}
    </div>
  );
};

export { Reply };
